import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { Button } from '../components/ui/button';
import { KawaTechLogo } from '../branding/kawatech';

const SignupPage = () => (
  <div className="grid min-h-screen bg-background lg:grid-cols-[41%_59%]">
    <section className="flex min-h-screen items-center justify-center px-6 py-12">
      <div className="w-full max-w-[430px] text-center" data-testid="signup-disabled-page">
        <KawaTechLogo className="mx-auto mb-8 h-9 w-auto" />
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary text-primary-foreground">
          <ShieldCheck className="h-9 w-9" />
        </span>
        <h1 className="mt-8 text-4xl font-extrabold text-secondary">Cadastro restrito</h1>
        <p className="mt-4 text-base leading-7 text-primary/75">
          O acesso ao KawaTenda é criado por um administrador da empresa. Solicite a criação da sua conta para continuar.
        </p>
        <Button asChild className="mt-8 h-12 w-full bg-primary text-base font-bold">
          <Link to="/login">Voltar para o login</Link>
        </Button>
      </div>
    </section>

    <section className="hidden min-h-screen items-center bg-primary px-20 py-16 text-white lg:flex">
      <div className="mx-auto max-w-[620px]">
        <KawaTechLogo variant="negative" className="h-10 w-auto" />
        <h2 className="mt-10 text-5xl font-extrabold leading-tight">
          Contas criadas com controle administrativo
        </h2>
        <p className="mt-5 text-lg leading-8">
          Cada usuário entra pelo fluxo oficial da empresa, preservando isolamento por tenant e acesso por perfil.
        </p>
      </div>
    </section>
  </div>
);

export default SignupPage;
